import React from "react";
import { getNormalizedBlockName } from "./utils";
import { blocksList } from "./BlocksList";
import { Block } from "../../types/Block";
import { get } from "lodash";

type RenderBlockProps = {
  blockData: Block;
};

const LINK_PRODUCT = "sonata.block.service.link_product";

const RenderBlock: React.FunctionComponent<RenderBlockProps> = ({
  blockData,
}) => {
  if (blockData.type === LINK_PRODUCT) return <></>;

  const blockName = getNormalizedBlockName(blockData.type);
  const Component = get(blocksList, blockName);

  if (!Component) {
    console.error(`${blockName} block not found. Check the file BlocksList.ts`);
  }

  return <>{Component ? <Component blockData={blockData} /> : ""}</>;
};

export default RenderBlock;
